/* Root Selector */

export const getState = (state) => {
  return state.ticketEntryForm;
};

export const getShowModalFlag = (state) => {
  const { showTicketEntryFormModal } = getState(state);
  return showTicketEntryFormModal;
};
